import { selectFeatureSwitches } from 'tradera-state/environment/selectors';
import { selectShippingRegionCountryCodeIso2 } from 'tradera-state/shipping-region/selectors';
import { areCountryCodesIso2Equal } from 'tradera-utils/countrycode';

export const selectIsLoggedIn = state => state.member?.isLoggedIn;

export const selectGeolocation = state => state.member?.geolocation;

export const selectMemberId = state => state.member?.memberId;

export const selectMemberEmail = state => state.member?.memberEmail;

export const selectMemberCountryCodeIso2 = state =>
    state.member?.memberCountryCodeIso2;

export const selectIsOutsideSweden = state =>
    state.member?.geolocation?.isoCode &&
    state.member?.geolocation?.isoCode.toLowerCase() !== 'se';

export const showDanishFromCountry = state => {
    const fromCountry =
        selectShippingRegionCountryCodeIso2(state) ||
        selectMemberCountryCodeIso2(state);
    return (
        selectFeatureSwitches(state)['shipping-from-country'] &&
        areCountryCodesIso2Equal(fromCountry, 'DK')
    );
};
